import { render, staticRenderFns } from "./SearchFaqJumbotron.vue?vue&type=template&id=23e83e0e&scoped=true&"
import script from "./SearchFaqJumbotron.vue?vue&type=script&lang=js&"
export * from "./SearchFaqJumbotron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e83e0e",
  null
  
)

export default component.exports